import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	content: "",
	group: "block",
	marks: "",
	atom: !0,
	attrs: e({
		type: { default: "facebookLikeButton" },
		url: { default: "" }
	}),
	toDOM() {
		return ["div"];
	}
};
//#endregion
export { t as facebookLikeButtonSpec };
